import { render } from "./EditCollections.vue?vue&type=template&id=21bb1eaa"
import script from "./EditCollections.vue?vue&type=script&lang=js"
export * from "./EditCollections.vue?vue&type=script&lang=js"

import "./EditCollections.vue?vue&type=style&index=0&id=21bb1eaa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__